import PasswordResetConfirmTemplate from "../../templates/PasswordResetConfirmTemplate/PasswordResetConfirmTemplate";

const PasswordResetConfirm = ({ match }) => {
  return <PasswordResetConfirmTemplate uidb36={match.params.uidb36} token={match.params.token} />;
};
export default PasswordResetConfirm;
